module.exports = __webpack_public_path__ + "images/assets/5bcbd31455a5f11481258a8a2d87bf23.svg";